import React, {useEffect} from 'react';

const TextArea = ({id, value, onChange, placeholder, className, footer=null, icon=null, readOnly=false}) => {
    return <div className='input textarea'>
        {icon?<img src={icon} className='input-icon ml5' alt=''/>:<div className='ml30'/>}
        <img src='/images/input_spacer.png' className='textarea-spacer' alt=''/>
        <textarea className={className} type="text" id={id} placeholder={placeholder} value={value} readOnly={readOnly} onChange={(e) => onChange(e)} />
        {(placeholder && value.trim()!=='') && <div className='input-placeholder'>{placeholder}</div>}
        {(footer) && <div className='textarea-footer'>{footer}</div>}
    </div>;
};

export default TextArea;